var _rect, _path, _rect2, _path2, _path3, _path4, _rect3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditCards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 32,
    viewBox: "0 0 306 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.7709,
    y: 1.14583,
    width: 42.625,
    height: 29.7083,
    rx: 4.52083,
    fill: "white",
    stroke: "#DEDFE3",
    strokeWidth: 1.29167
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0109 20.9835H90.3504L88.3553 13.1484C88.2606 12.788 88.0596 12.4694 87.7638 12.3192C87.0257 11.9418 86.2124 11.6415 85.3251 11.49V11.1883H89.611C90.2025 11.1883 90.6461 11.6415 90.7201 12.1677L91.7552 17.8194L94.4144 11.1883H97.001L93.0109 20.9835ZM98.4798 20.9835H95.9672L98.0362 11.1883H100.549L98.4798 20.9835ZM103.799 13.9019C103.873 13.3744 104.317 13.0727 104.835 13.0727C105.648 12.997 106.534 13.1485 107.273 13.5245L107.717 11.4156C106.977 11.1139 106.164 10.9625 105.426 10.9625C102.987 10.9625 101.213 12.3192 101.213 14.2023C101.213 15.6348 102.47 16.387 103.357 16.8401C104.317 17.2919 104.687 17.5936 104.613 18.0454C104.613 18.7231 103.873 19.0248 103.135 19.0248C102.248 19.0248 101.361 18.7989 100.549 18.4215L100.105 20.5317C100.992 20.9078 101.952 21.0593 102.839 21.0593C105.574 21.1337 107.273 19.7782 107.273 17.7437C107.273 15.1817 103.799 15.0315 103.799 13.9019ZM116.067 20.9835L114.072 11.1883H111.929C111.485 11.1883 111.041 11.49 110.894 11.9418L107.199 20.9835H109.786L110.302 19.5523H113.48L113.776 20.9835H116.067ZM112.299 13.8262L113.037 17.5179H110.968L112.299 13.8262Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.688,
    y: 1.14583,
    width: 42.625,
    height: 29.7083,
    rx: 4.52083,
    fill: "white",
    stroke: "#DEDFE3",
    strokeWidth: 1.29167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.912 24.3054C163.75 24.3054 167.671 20.4308 167.671 15.6512C167.671 10.8717 163.75 6.99707 158.912 6.99707C156.745 6.99707 154.761 7.77532 153.231 9.06448C151.702 7.77533 149.718 6.9971 147.55 6.9971C142.713 6.9971 138.792 10.8717 138.792 15.6513C138.792 20.4308 142.713 24.3054 147.55 24.3054C149.718 24.3054 151.702 23.5272 153.231 22.238C154.761 23.5272 156.745 24.3054 158.912 24.3054Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 22.2381C155.114 20.6507 156.309 18.2888 156.309 15.6512C156.309 13.0137 155.114 10.6517 153.231 9.0644C154.761 7.77528 156.744 6.99707 158.912 6.99707C163.749 6.99707 167.671 10.8717 167.671 15.6512C167.671 20.4308 163.749 24.3054 158.912 24.3054C156.744 24.3054 154.761 23.5272 153.231 22.2381Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 22.238C155.114 20.6507 156.309 18.2887 156.309 15.6512C156.309 13.0137 155.114 10.6518 153.231 9.06445C151.348 10.6518 150.154 13.0137 150.154 15.6512C150.154 18.2887 151.348 20.6507 153.231 22.238Z",
    fill: "#FF5E00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 183.604,
    y: 1.14583,
    width: 42.625,
    height: 29.7083,
    rx: 4.52083,
    fill: "#1F72CD",
    stroke: "#DEDFE3",
    strokeWidth: 1.29167
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.832 11.4792L186.723 20.8396H191.642L192.251 19.3471H193.645L194.255 20.8396H199.67V19.7005L200.152 20.8396H202.953L203.435 19.6764V20.8396H214.696L216.065 19.3859L217.347 20.8396L223.131 20.8516L219.009 16.1855L223.131 11.4792H217.437L216.104 12.906L214.862 11.4792H202.612L201.56 13.8952L200.484 11.4792H195.575V12.5795L195.029 11.4792H190.832ZM191.783 12.8084H194.181L196.907 19.1557V12.8084H199.533L201.638 17.3594L203.578 12.8084H206.192V19.525H204.602L204.589 14.2619L202.27 19.525H200.848L198.516 14.2619V19.525H195.245L194.625 18.0193H191.274L190.655 19.5237H188.902L191.783 12.8084ZM214.113 12.8084H207.647V19.5211H214.013L216.065 17.2964L218.043 19.5211H220.11L217.105 16.1842L220.11 12.8084H218.132L216.091 15.0075L214.113 12.8084ZM192.95 13.9448L191.846 16.6272H194.052L192.95 13.9448ZM209.244 15.4252V14.199V14.1979H213.278L215.039 16.1588L213.2 18.1304H209.244V16.7918H212.771V15.4252H209.244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCards);
export default __webpack_public_path__ + "static/media/icon-credit-cards.fe619e51eaa0651371485e4cb0468e11.svg";
export { ForwardRef as ReactComponent };